import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'
import {
  InsightsContainer,
  InsightsHeader,
  HeaderLeft,
  HeaderActions,
  MetaRow,
  MetaBadge,
  Divider,
  QuestionsGrid,
} from '../../../features/survey/pages/SurveyInsightsPageStyles'
import styled from 'styled-components'

const QuestionCard = styled.div`
  background: var(--color-bg-card);
  border: 1px solid var(--color-border-card);
  border-radius: ${BORDER_RADIUS.xl};
  padding: ${SPACING.xl};
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md};
`

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const BarRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md};
`

export function SkeletonSurveyInsights() {
  return (
    <InsightsContainer>
      {/* Page header */}
      <InsightsHeader>
        <HeaderLeft>
          <SkeletonBox
            $width="300px"
            $height="28px"
            $radius={BORDER_RADIUS.lg}
            style={{ marginBottom: SPACING.xs }}
          />
          <SkeletonBox $width="180px" $height="16px" $radius={BORDER_RADIUS.sm} />
        </HeaderLeft>
        <HeaderActions>
          <SkeletonBox $width="36px" $height="32px" $radius={BORDER_RADIUS.lg} />
          <SkeletonBox $width="130px" $height="32px" $radius={BORDER_RADIUS.lg} />
        </HeaderActions>
      </InsightsHeader>

      {/* Meta badges */}
      <MetaRow>
        {[100, 90, 110].map((w, i) => (
          <MetaBadge key={i}>
            <SkeletonBox $width={`${w}px`} $height="14px" $radius={BORDER_RADIUS.sm} />
          </MetaBadge>
        ))}
      </MetaRow>

      <Divider />

      {/* Question insight cards */}
      <QuestionsGrid>
        {[
          { barCount: 4, labelWidths: [70, 55, 85, 60] },
          { barCount: 3, labelWidths: [80, 65, 75] },
          { barCount: 5, labelWidths: [60, 90, 70, 50, 80] },
        ].map((card, ci) => (
          <QuestionCard key={ci}>
            <CardHeader>
              <SkeletonBox $width="55%" $height="16px" $radius={BORDER_RADIUS.sm} />
              <SkeletonBox $width="60px" $height="22px" $radius={BORDER_RADIUS.full} />
            </CardHeader>
            {card.labelWidths.map((lw, ri) => (
              <BarRow key={ri}>
                <SkeletonBox
                  $width={`${lw}px`}
                  $height="13px"
                  $radius={BORDER_RADIUS.sm}
                  style={{ flexShrink: 0 }}
                />
                <SkeletonBox
                  $width={`${30 + ri * 12}%`}
                  $height="20px"
                  $radius={BORDER_RADIUS.md}
                />
                <SkeletonBox
                  $width="28px"
                  $height="13px"
                  $radius={BORDER_RADIUS.sm}
                  style={{ flexShrink: 0 }}
                />
              </BarRow>
            ))}
          </QuestionCard>
        ))}
      </QuestionsGrid>
    </InsightsContainer>
  )
}
